/*
  Land-related mixins.
  ------------------------------------------------------------------------ */

import DateMixins from '@/mixins/DateMixins'
import NumberMixins from '@/mixins/NumberMixins'

export default {
  mixins: [DateMixins, NumberMixins],

  methods: {
    isValue (data, value) {
      return (data && value ? (data.landType === value) : false)
    },


    isPurchase (data) {
      return this.isValue(data, 'Purchase')
    },


    isRental (data) {
      return this.isValue(data, 'Rental')
    },


    isLease (data) {
      return this.isValue(data, 'Leased')
    },

    renewalCalc (data, currentAmount, increment, taxable) {

      if (data) {

        if (data.started) {
          data.started = this.formatDateSql(data.started)
        }

        if (data.started) {
          data.expiry = this.contractExpiryDate(data.started, data.months, 'months')
          data.expiry = this.formatDateSql(data.expiry)
        }

        let per = this.formatPercentage(currentAmount, increment)
        data.total = currentAmount + per

        data.taxable = taxable
        data.tax = this.taxDue(data.total, data.taxable)
        data.total = this.totalDue(data.total, data.tax)

      }

      return data
    }

  }
}



// WEBPACK FOOTER //
// ./src/mixins/TenancyMixins.js